
// Función para limpiar el estado de autenticación (previene estados "limbo")
export const cleanupAuthState = () => {
  // Eliminar tokens estándar de autenticación
  localStorage.removeItem('supabase.auth.token');
  // Eliminar todas las claves de autenticación de Supabase del localStorage
  Object.keys(localStorage).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      localStorage.removeItem(key);
    }
  });
  // Eliminar del sessionStorage si se usa
  Object.keys(sessionStorage || {}).forEach((key) => {
    if (key.startsWith('supabase.auth.') || key.includes('sb-')) {
      sessionStorage.removeItem(key);
    }
  });
};
